import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import refreshFinancingContent from 'commons/refreshFinancingContent';
import useAffirmScript from 'hooks/useAffirmScript';
import poll from 'commons/poll';

// The Affirm script injects link elenents that show the Affirm modal when
// clicked. The default Affirm links include extra information that is not
// needed in the Consumer app, so we normally hide the default Affirm link and
// use a custom button to trigger the Affirm modal instead.

// A ref to the wrapper element where the default link is injected should be
// passed into this hook
const useAffirmRefreshHTML = defaultLinkWrapperRef => {
  const $ = _c(7);
  const [isDefaultLinkLoaded, setIsDefaultLinkLoaded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      onLoad: refreshFinancingContent
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useAffirmScript(t0);
  let t1;
  let t2;
  if ($[1] !== defaultLinkWrapperRef) {
    t1 = () => {
      if (!defaultLinkWrapperRef) {
        return null;
      }
      const clearTimer = poll({
        condition: () => {
          const isAffirmScriptReady = !!(window?.affirm?.ui?.ready && window?.affirm?.ui?.refresh && defaultLinkWrapperRef?.current);
          return isAffirmScriptReady;
        },
        callback: refreshFinancingContent,
        interval: 250,
        maxRetries: 80
      });
      return clearTimer;
    };
    t2 = [defaultLinkWrapperRef];
    $[1] = defaultLinkWrapperRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== defaultLinkWrapperRef) {
    t3 = () => {
      if (!defaultLinkWrapperRef) {
        return null;
      }
      const clearTimer_0 = poll({
        condition: () => {
          const affirmWrapper = defaultLinkWrapperRef?.current;
          const affirmLinkOrButton = affirmWrapper?.querySelector?.("a,button");
          return !!affirmLinkOrButton;
        },
        callback: () => {
          setIsDefaultLinkLoaded?.(true);
        },
        interval: 250,
        maxRetries: 80
      });
      return clearTimer_0;
    };
    t4 = [defaultLinkWrapperRef];
    $[4] = defaultLinkWrapperRef;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  return isDefaultLinkLoaded;
};
export default useAffirmRefreshHTML;